import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * OrthopaedistSpine icon
 *
 * @category Medical
 */
const OrthopaedistSpine = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M26.04 23.237c-.4-2.31-3.24-2.63-5.08-2.11-.5.1-1.88.56-1.34-.36.55-1.02 2.77-1.42 2.6-2.84-.14-1.21-2.45-1.28-2.39-2.32.07-1.38 2.44-1.45 2.41-2.9-.03-1.35-2.07-1.21-2.39-2.33-.26-1.35 2.89-1.77 2.34-3.3-.39-.95-1.58-1.17-2.41-1.66-1.09-.65-2.19 0-3.32.04-1.07-.05-2.22-.68-3.23-.11-.75.39-1.59.72-2.15 1.35-1.18 1.76 1.93 2.11 1.97 3.55.04.98-2.1 1.16-2.21 2.35-.1 1.1 1.17 1.57 1.83 2.18 1.13 1.12-.42 1.76-1.25 2.3-.95.62-.63 1.8.28 2.35.59.48 1.65.95 1.7 1.73-.12.19-1.15-.2-2.1-.23-.83-.04-1.72-.02-2.5.28-2.67.92-2.83 4.45-.22 5.45 1.26.53 2.51.05 3.73-.29 1.64-.54 3 .65 4.62.37.91-.12 1.76-.55 2.68-.56 1.61.03 3.24 1.1 4.71.54 1.34-.43 1.99-1.98 1.74-3.3l-.04-.18zM12.3 8.217c-1.3-.64-.47-.97.36-1.36.66-.38 1.15-.84 1.75-.61.77.32 1.98.54 2.93.35.76-.14 1.51-.66 2.22-.13.53.44 1.37.59 1.85 1.01.07.11.02.25-.12.38-.97.56-1.92 1.14-2.61 2.11-.84 1.12-2.15 1.53-3.36.92-1.05-.64-1.77-2.03-2.86-2.58l-.15-.08zm-.04 5.25c-1.02-.53-.72-.91.17-1.28.85-.52 1.59-.99 2.62-.5.91.28 1.93.29 2.84 0 .62-.21 1.14-.36 1.63-.05.52.45 1.47.6 1.89 1.09.04.53-.79.72-1.2 1.04-1.01.59-1.64 1.87-2.6 2.41-2.56 1.17-3.41-1.62-5.21-2.63l-.15-.08zm.01 5.25c-.41-.22-.76-.51-.6-.76.1-.12.04-.11.47-.34.57-.23 1.12-.72 1.71-.84 1.05-.07 2.26.64 3.39.31.81-.16 1.73-.63 2.39-.09.51.44 1.4.53 1.79 1.02.05.12-.02.25-.17.38-.72.47-1.51.81-2.08 1.53-.94 1.3-2.42 2.37-3.96 1.43-1.03-.7-1.69-1.99-2.79-2.55zm11.74 6.96c-1.71.44-3.47-1.06-5.26-.53-1.08.27-2.16.75-3.29.39-1.12-.37-2.28-.67-3.44-.24-5.15 2.25-6.04-4.19-.58-3.53 1.71.27 3.34.82 5.12.75 2.32.15 4.15-.69 6.35-.75 2.14-.13 3.07 2.83 1.24 3.85l-.15.06z"
        />
      </svg>
    );
  }
);

OrthopaedistSpine.displayName = 'OrthopaedistSpine';

export { OrthopaedistSpine };
